/* unplugin-vue-components disabled */import script from "./Initiative.vue?vue&type=script&setup=true&lang=js"
export * from "./Initiative.vue?vue&type=script&setup=true&lang=js"

import "./Initiative.vue?vue&type=style&index=0&id=7f3b1b6e&lang=scss&scoped=true"

import exportComponent from "D:\\H5Projects\\1carbon\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f3b1b6e"]])

export default __exports__